// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3qqTm","footer":"ModalCreateQualiphyProcedure_footer__RFfpk","additionData":"ModalCreateQualiphyProcedure_additionData__3A8jJ"};